import React, { useEffect, useState } from "react";
import Navlink from "components/navlink";
import logo from "assets/images/Cowva.svg";
import cancel from "assets/icons/cancel.svg";
import { bottomSidebarRoutes, topSidebarRoutes } from "constant/routes";
import { useMenuToggler, useActiveRoutes, useSidebar, useUser } from "hooks";
import plusIcon from "assets/icons/add-icon.svg";
import minusIcon from "assets/icons/minus-icon.svg";
import userIcon from "assets/icons/user-business.svg";
import familyIcon from "assets/icons/family-inactive.svg";
import { getTokenFromLocalStore } from "utils";
import { IRoutesProps } from "types";

export default function MobileSidebar() {
  const { closeMenu, isOpen } = useMenuToggler();
  const { user } = useUser();

  const userRoles: string[] = getTokenFromLocalStore("roles") || [];

  const [openDropdown, setOpenDropdown] = useState<string>("user");
  const [visibleRoutes, setvisibleRoutes] =
    useState<IRoutesProps[]>(topSidebarRoutes);
  const { activeTopRoutes, activeBottomRoutes, activeAefiSidebarRoutes } =
    useActiveRoutes(visibleRoutes, bottomSidebarRoutes, userRoles);

  const [hfRoutes, setHfRoutes] = useState<Record<string, IRoutesProps[]>>(
    activeAefiSidebarRoutes
  );

  const handleDropdownToggle = (role: string) => {
    setOpenDropdown((prev) => (prev === role ? "" : role));
  };

  useEffect(() => {
    if (user?.email) {
      setvisibleRoutes((prevRoutes) =>
        prevRoutes?.map((route) =>
          route.path === "/manage-family-accounts"
            ? { ...route, shouldShow: true }
            : route.path === "/wallet"
            ? { ...route, shouldShow: true }
            : route.path === "/book-appointment"
            ? { ...route, shouldShow: true }
            : route
        )
      );
    }
  }, [user]);

  useEffect(() => {
    const facilityRoles: any[] = getTokenFromLocalStore("facility_roles") || [];
    const updatedRoutes = Object.keys(activeAefiSidebarRoutes).reduce(
      (acc, key) => {
        const matchedFacility = facilityRoles.find(
          (facility) => facility.hfSlug === key
        );

        if (matchedFacility) {
          acc[key] = activeAefiSidebarRoutes[key].map((route) => ({
            ...route,
            shouldShow:
              matchedFacility.hfRole === "hf_owner" ? true : route.shouldShow,
          }));
        }

        return acc;
      },
      {} as Record<string, IRoutesProps[]>
    );

    if (JSON.stringify(updatedRoutes) !== JSON.stringify(hfRoutes)) {
      setHfRoutes(updatedRoutes);
    }
  }, [activeAefiSidebarRoutes, hfRoutes]);

  const renderRoutes = (routes: typeof visibleRoutes) => {
    return routes
      .filter((route) => route.shouldShow)
      .map((route, index) => (
        <Navlink
          key={index}
          icon={route.icon}
          inactiveIcon={route.inactiveIcon}
          label={route.label}
          path={route.path}
          isActive={route.isActive}
          showLabel
          hasSubRoute={route.hasSubRoute}
          subRoute={route.subRoute}
        />
      ));
  };

  return (
    <div
      className={`bg-[#0f0e0e66] w-full h-dvh absolute z-50 left-0 top-0 ${
        isOpen ? "block" : "hidden"
      }`}
    >
      <div className="w-[80%] h-full flex flex-col justify-between px-3 py-5 bg-white overflow-y-scroll">
        <div className="flex flex-col gap-5 h-fit">
          <div className="flex justify-between items-center">
            <img src={logo} alt="" />
            <img src={cancel} alt="" onClick={closeMenu} />
          </div>
          <div className="w-full px-2 flex flex-col gap-1">
            {userRoles.length > 1
              ? userRoles.map((role, roleIndex) => (
                  <div key={roleIndex}>
                    <div
                      className={`flex justify-between items-center cursor-pointer pl-4 h-[50px] ${
                        openDropdown === role ? "font-bold" : ""
                      }`}
                      onClick={() => {
                        handleDropdownToggle(role);
                      }}
                    >
                      {role === "user" ? (
                        <span className="flex gap-3 items-center">
                          <img src={userIcon} alt="" />
                          <span>User</span>
                        </span>
                      ) : (
                        <span className="flex gap-3 items-center">
                          <img src={familyIcon} alt="" />
                          <span>{role}</span>
                        </span>
                      )}

                      <button>
                        {openDropdown === role ? (
                          <img src={minusIcon} alt="Toggle Icon" />
                        ) : (
                          <img src={plusIcon} alt="Toggle Icon" />
                        )}
                      </button>
                    </div>

                    {openDropdown === role && (
                      <div className="pl-4 flex flex-col gap-1">
                        {role === "user"
                          ? renderRoutes(activeTopRoutes)
                          : renderRoutes(hfRoutes[role] || [])}
                      </div>
                    )}
                  </div>
                ))
              : renderRoutes(
                  userRoles[0] === "user"
                    ? activeTopRoutes
                    : hfRoutes[userRoles[0]] || []
                )}
          </div>
        </div>
        <div className="w-full px-2 flex flex-col gap-1 h-fit">
          {renderRoutes(activeBottomRoutes)}
        </div>
      </div>
    </div>
  );
}
